import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import { connectLean } from 'lean-redux';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import LockedProgressBar from 'legacy-packages/unit-outline/src/components/AssessmentProgress/LockedProgressBar';
import LearnosityProvider from 'legacy-src/utility/LearnosityProvider';
import PerformanceBar from 'legacy/src/components/assessment/Results/PerformanceBar/index';
import { performanceTierStacks } from 'legacy-src/utility/progressHelpers';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { QuestionTypes } from '../../../constants';
import {
  getPriorStudentsSubdir,
  getSubGroupStudentsLabel,
} from 'legacy/src/utility/utils';
import PopoverActionButton from '../PopoverActionButton';
import AssignItem from 'legacy/src/components/assessment/AssignItem';
import useAttestation from 'legacy/src/components/assessment/hooks/useAttestation';

//chameleon imports
import ScoredIcon from 'chameleon/ui-stack/ui/assessments/scored-icon';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import Button from 'chameleon/ui-stack/ui/base/button';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import SPPProgressBarPopover from 'chameleon/ui-stack/ui/assessments/spp-progress-bar';
import connectLeanUpdateAssignments from 'chameleon-src/utility/connectLeanUpdateAssignments';
import { SubunitAssessmentTypes } from 'legacy-packages/unit-outline/src/constants';
import { computeAssignmentsReadyToScore } from 'chameleon/src/components/learnosity/utils/helpers';
import './index.scss';
import usePerformanceTiers from 'chameleon/src/hooks/usePerformanceTiers';

export const SUBMISSIONS_TO_SCORE_TEXT = 'to Score';
const VIEW_RESULTS_TEXT = 'View Results';
const MANAGE_ASSIGNMENT_TEXT = 'Manage Assignment';

const ProgressPopoverClass = (props) => {
  const {
    assignment,
    subjectId,
    isFirst,
    routes,
    showAttestationConfirmationDialog,
    isPreApSubject,
    onItemAction,
    saveAssignedState,
    subunitType,
    useNewAssignModalFlag,
    studentsBySection,
  } = props;

  const { performanceTiers } = usePerformanceTiers(subjectId);

  const { assessment, status: assignmentStatus } = assignment;
  const { questions } = assessment;
  const isFRQ = questions.some(
    (question) => question.type === QuestionTypes.FREE_RESPONSE_QUESTION,
  );

  const progress = {
    ...assignment.progress,
    mcq_scoring: assignment.progress.mcqScoring,
    not_started: assignment.progress.notStarted,
    student_scored: assignment.progress.studentScored,
    ready_to_score: assignment.progress.readyToScore,
    teacher_and_student_scored: assignment.progress.teacherAndStudentScored,
  };

  const assignmentsReadyToScore = computeAssignmentsReadyToScore(
    assignment.progress,
  );

  const [learnosityReport, setLearnosityReport] = useState();
  const {
    students = [],
    teacherAssigned,
    startsAt,
    dueAt,
    sectionId,
    title,
    isSecure,
    scrambleQuestions,
    assessment: { id: assessmentId, isPracticeExam } = {},
    isIndividualAssignment,
  } = assignment || {};

  // FY-21581 for UX refresh we don't use the 80% rule anymore
  const isScored =
    progress.student_scored +
      progress.teacher_and_student_scored +
      progress.scored +
      progress.complete >
    0;

  const getStacks = () =>
    performanceTierStacks(
      students && students.length,
      learnosityReport,
      performanceTiers,
      students,
    );
  const subGroupStudentsLabel =
    isIndividualAssignment && getSubGroupStudentsLabel(students);

  // FY-8265 in a case class dont have students
  if (isEmpty(students)) {
    progress.not_started = -1;
  }

  const assignmentProgressLink = `/${subjectId}/assignments/progress/${
    assignment.id
  }${getPriorStudentsSubdir(routes)}`;
  const assignmentResultsLink = isPreApSubject
    ? `/${subjectId}/aggregate/results/${assignment.id}/summary`
    : `/${subjectId}/assessments/results/${
        assignment.id
      }${getPriorStudentsSubdir(routes)}`;

  const isNotAssigned = !teacherAssigned;
  const isLocked = assignmentStatus === 'locked';

  const selectedGroups = {
    assign: [Number.parseInt(sectionId, 10)],
  };
  const { hasScrambleablePEs } = useAttestation({
    showAttestationFlag: showAttestationConfirmationDialog,
  });

  const onAssignItem = (assignmentsResponse, totalAssignees) => {
    connectLeanUpdateAssignments({
      assignmentsResponse,
      totalAssignees,
      saveAssignedState,
      onItemAction,
      useNewAssignModalFlag,
      studentsBySection,
    });
  };

  let assignBtn = (
    <Button
      isPrimary
      tabIndex={0}
      accessibility={{ 'aria-label': 'Unlock Schedule' }}
    >
      Unlock / Schedule
    </Button>
  );
  /* FY-23754 for PE show the Assign button */
  if (subunitType === SubunitAssessmentTypes.PE) {
    assignBtn = (
      <ButtonWithIcon
        tabIndex={0}
        isPrimary
        icon="person_add"
        iconClassName="fill-current text-white"
        accessibility={{
          'aria-label': 'Assign Quiz',
        }}
      >
        Assign
      </ButtonWithIcon>
    );
  }
  const viewResults = (
    <PopoverActionButton
      data-test-view-results-button
      actionLink={assignmentResultsLink}
      hasButtonMargin={isFRQ}
    >
      {VIEW_RESULTS_TEXT}
    </PopoverActionButton>
  );
  const notScoredContainerRowContent = assessment.isSPP ? (
    <SPPProgressBarPopover
      isUnassigned={false}
      isActivePopover={false}
      assignment={assignment}
      students={assignment.students.map((student) => ({
        ...student,
        id: parseInt(student.id, 10),
      }))}
    />
  ) : (
    <LockedProgressBar
      data-test-progress-bar
      isSmall
      assignmentProgress={progress}
      isScheduled={!!teacherAssigned}
      startsAt={startsAt}
      dueAt={dueAt}
      hasStudents={students.length > 0}
    />
  );
  const notScoredContainerRow = (
    <Link to={assignmentProgressLink}>{notScoredContainerRowContent}</Link>
  );

  const assignedOn =
    assignment.teacherAssigned &&
    new Date(assignment.teacherAssigned).toLocaleDateString();

  const classSection = (
    <section
      className="popover-content-class"
      aria-labelledby={`name-${assignment.item_id}`}
    >
      {!assessment.isSPP && (
        <div className="ml-4">
          <Icon
            id={isNotAssigned || isLocked ? 'lock' : 'unlock'}
            className="fill-current text-black"
          />
        </div>
      )}
      <div
        className="classname ml-4"
        data-test-classname
        id={`name-${assignment.item_id}`}
      >
        {assignment.sectionName}
        {subGroupStudentsLabel}
      </div>

      <div className="date mr-8">
        {assignedOn ? (
          <span>
            <span className="sr-only">Assigned on</span> {assignedOn}
          </span>
        ) : (
          <span>&mdash;</span>
        )}
      </div>

      <div className="progress-bar-container">
        {(() => {
          if (!isScored) {
            return (
              <div className="scored-container">{notScoredContainerRow}</div>
            );
          }
          return (
            <Fragment>
              {learnosityReport ? (
                <div className="scored-container">
                  <Link to={assignmentResultsLink}>
                    {assessment.isSPP ? (
                      <SPPProgressBarPopover
                        isUnassigned={false}
                        isActivePopover={false}
                        assignment={{
                          ...assignment,
                          report: learnosityReport[0],
                          students_who_submitted_spp: assignment.studentSessions
                            .filter((student) => !!student.submittedAt)
                            .map((student) => parseInt(student.userId, 10)),
                        }}
                        students={assignment.students.map((student) => ({
                          ...student,
                          id: parseInt(student.id, 10),
                        }))}
                      />
                    ) : (
                      <PerformanceBar stacks={getStacks()} isSmall />
                    )}
                  </Link>
                  <div>
                    <ScoredIcon
                      teacherAndStudentScored={progress.teacherAndStudentScored}
                      studentScored={progress.studentScored}
                      teacherScored={progress.scored}
                    />
                  </div>
                </div>
              ) : (
                <LoadingSpinner height={34} />
              )}
              <LearnosityProvider
                apiType="reports"
                initOptions={JSON.parse(assignment.results)}
                dataListener={setLearnosityReport}
              />
            </Fragment>
          );
        })()}
      </div>

      <div className="actions-container ml-auto mr-4 flex shrink-0 grow-0 items-center">
        {(() => {
          if (isNotAssigned) {
            return (
              <AssignItem
                selectedGroups={selectedGroups}
                groups={[]}
                itemId={Number.parseInt(assessmentId, 10)}
                itemTitle={title}
                hideSecureToggle={!isSecure}
                onAssign={onAssignItem}
                onAssignRedirect={false}
                scrambleable={
                  scrambleQuestions || hasScrambleablePEs(isPracticeExam)
                }
                button={assignBtn}
              />
            );
          }
          if (!isScored) {
            return (
              <PopoverActionButton
                data-test-score-submissions-button
                actionLink={assignmentProgressLink}
              >
                {assignmentsReadyToScore > 0 && !assessment.isSPP
                  ? `${assignmentsReadyToScore} ${SUBMISSIONS_TO_SCORE_TEXT}`
                  : MANAGE_ASSIGNMENT_TEXT}
              </PopoverActionButton>
            );
          }
          return (
            <Fragment>
              {(() => {
                if (assignmentsReadyToScore > 0 && !assessment.isSPP) {
                  return (
                    <Fragment>
                      <div className="mr-4">
                        <Link to={assignmentResultsLink}>
                          <Button
                            tabIndex={0}
                            accessibility={{
                              'aria-label': VIEW_RESULTS_TEXT,
                            }}
                            isLink
                            isNaked
                          >
                            {VIEW_RESULTS_TEXT}
                          </Button>
                        </Link>
                      </div>
                      <PopoverActionButton
                        data-test-score-submissions-button
                        actionLink={assignmentProgressLink}
                      >
                        {`${assignmentsReadyToScore} ${SUBMISSIONS_TO_SCORE_TEXT}`}
                      </PopoverActionButton>
                    </Fragment>
                  );
                }
                return (
                  <Fragment>
                    <Fragment>
                      <div className="mr-2">
                        <Link to={assignmentProgressLink}>
                          <Button
                            tabIndex={0}
                            accessibility={{
                              'aria-label': MANAGE_ASSIGNMENT_TEXT,
                            }}
                            isLink
                            isNaked
                          >
                            {MANAGE_ASSIGNMENT_TEXT}
                          </Button>
                        </Link>
                      </div>

                      {viewResults}
                    </Fragment>
                  </Fragment>
                );
              })()}
            </Fragment>
          );
        })()}
      </div>
    </section>
  );

  return (
    <Fragment>
      {isFirst ? (
        <Fragment>{classSection}</Fragment>
      ) : (
        assignment && <Fragment>{classSection}</Fragment>
      )}
    </Fragment>
  );
};

ProgressPopoverClass.propTypes = {
  isFirst: PropTypes.bool,
  assignment: PropTypes.object.isRequired,
  subjectId: PropTypes.string.isRequired,
  showAttestationConfirmationDialog: PropTypes.bool.isRequired,
  subunitType: PropTypes.string,
  useNewAssignModalFlag: PropTypes.bool,
};

ProgressPopoverClass.defaultProps = {
  isFirst: false,
  subunitType: 'PPC',
};

const mapStateToProps = ({ featureFlag, studentsBySection }) => {
  return {
    useNewAssignModalFlag: featureFlag.new_assign_modal,
    studentsBySection,
  };
};

export default compose(
  connectLean({
    saveAssignedState(updatedAssignmentsInfo) {
      const { assignmentOverview = {} } = this.state;
      const { assignments = [] } = assignmentOverview;
      this.setState({
        assignmentOverview: {
          ...assignmentOverview,
          assignments: [...assignments, ...updatedAssignmentsInfo],
        },
      });
    },
  }),
  withRouter,
  connect(mapStateToProps),
)(ProgressPopoverClass);
